import { AJAX_GET, AJAX_POST } from '@/helpers/ajax.js'

export default {
    async changeEmail(payload) {
        return await AJAX_POST('/change-email', payload) 
    },
    
}